import { render, staticRenderFns } from "./session_notes.vue?vue&type=template&id=0abdf2bc&"
import script from "./session_notes.vue?vue&type=script&lang=js&"
export * from "./session_notes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0abdf2bc')) {
      api.createRecord('0abdf2bc', component.options)
    } else {
      api.reload('0abdf2bc', component.options)
    }
    module.hot.accept("./session_notes.vue?vue&type=template&id=0abdf2bc&", function () {
      api.rerender('0abdf2bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/sessions/session_notes.vue"
export default component.exports